document.addEventListener('DOMContentLoaded', ()=>{
    // ================================
    // JS pour le card contact
    // ================================
    const buttons = document.querySelectorAll(".card-buttons button");
    const sections = document.querySelectorAll(".card-section");
    const card = document.querySelector(".card");
    const handleButtonClick = (e)=>{
        const targetSection = e.target.getAttribute("data-section");
        const section = document.querySelector(targetSection);
        targetSection !== "#about" ? card.classList.add("is-active") : card.classList.remove("is-active");
        card.setAttribute("data-state", targetSection);
        sections.forEach((s)=>s.classList.remove("is-active"));
        buttons.forEach((b)=>b.classList.remove("is-active"));
        e.target.classList.add("is-active");
        section.classList.add("is-active");
    };
    buttons.forEach((btn)=>{
        btn.addEventListener("click", handleButtonClick);
    });
    // ================================
    // JS pour le form contacter-nous
    // ================================
    document.getElementById('form').addEventListener('submit', async function(event) {
        event.preventDefault();
        // Executer reCAPTCHA
        const token = await grecaptcha.execute("6LeOXxAsAAAAALezJBx3XvUNB5VmW34pcJF68GxU", {
            action: 'submit'
        });
        const formData = new FormData(this);
        const data = {
            name: formData.get('name'),
            surname: formData.get('surname'),
            email: formData.get('email'),
            motif: formData.get('motif'),
            message: formData.get('message'),
            "g-recaptcha-response": token
        };
        try {
            const response = await fetch('/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                this.reset();
                const modal = document.getElementById("myModal");
                modal.style.display = "block";
            }
        } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur lors de l\'envoi de l\'email');
        }
    });
    // ================================
    // Modal
    // ================================
    const span = document.getElementsByClassName("close")[0];
    span.onclick = function() {
        const modal = document.getElementById("myModal");
        modal.style.display = "none";
    };
    window.onclick = function(event) {
        const modal = document.getElementById("myModal");
        if (event.target == modal) modal.style.display = "none";
    };
    // ================================
    // Bandeau Cookies
    // ================================
    function loadGA() {
        if (window.gtag) return; // évite double chargement
        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-1REVZLTGVG';
        script.async = true;
        document.head.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            dataLayer.push(arguments);
        };
        gtag('js', new Date());
        gtag('config', 'G-1REVZLTGVG');
    }
    const banner = document.getElementById('cookie-banner');
    const acceptBtn = document.getElementById('accept-all');
    const rejectBtn = document.getElementById('reject-all');
    if (banner && acceptBtn && rejectBtn) {
        const consent = localStorage.getItem('cookiesAccepted');
        if (!consent) banner.style.display = 'flex';
        else if (consent === 'all') loadGA();
        else banner.style.display = 'none';
        acceptBtn?.addEventListener('click', ()=>{
            localStorage.setItem('cookiesAccepted', 'all');
            banner.style.display = 'none';
            loadGA();
        });
        rejectBtn?.addEventListener('click', ()=>{
            localStorage.setItem('cookiesAccepted', 'none');
            banner.style.display = 'none';
        });
    }
});

//# sourceMappingURL=sokapp.dev.805c321c.js.map
